export default __webpack_public_path__ + "static/media/image55.0289e8ad.png";